import { DataTable } from "@/components/datatable/datatable"
import { DataTableSupabase } from "@/components/datatable/supadatatable"
import { Page, PageTitle } from "@/components/page"
import { usePage } from "@/components/page/hooks"
import { Button } from "@/components/ui/button"
import { supabase } from "@/lib/data"
import { useTeamStore } from "@/lib/hooks/useTeam"
import { Radio, Plus, Trash2, Copy } from "lucide-react"
import { useCallback } from "react"
import { CHANNEL_WEBHOOK_BASE } from "./webhooks"
import { useAssistantChangeKey } from "@/lib/assistant/modules/channels"


export const channels = {
  title: "Channels",
  description: "Manage your organization's Channels.",
  route: "/settings/channels",
  url: "/settings/channels",
  icon: Radio,
  component,
  group: "communications",
  resource: "apikeys",
  action: "read",
} satisfies PageConfig

const debounceTypes = {
  none: "None",
  singleAgentInstance: "Single Agent Instance",
  debounce: "Debounce",
} as const

const types = {
  app: "App",
  telerivet: "Telerivet",
  whatsapp: "WhatsApp",
  messenger: "Facebook Messenger",
  instagram: "Instagram",
  telegram: "Telegram",
} as const

const columns: Columns<Channel> = {
  title: { header: "Title", size: 240 },
  type: { header: "Type", size: 120, cell: ({ row }) => types[row.original.type] },
  agent: { header: "Agent", size: 100, cell: ({ row }) => row.original.agent?.["title"] },
  debounce_type: { header: "Debounce Type", size: 140, cell: ({ row }) => debounceTypes[row.original.debounce_type] },
  debug: { header: "Debug", cell: DataTable.cellRender.boolean, size: 90 },
  created_at: { header: "Created", cell: DataTable.cellRender.date, size: 166 },
}

const QABaseURL = CHANNEL_WEBHOOK_BASE.qa
const PRODBaseURL = CHANNEL_WEBHOOK_BASE.prod

function component() {

  const { selectedTeam } = useTeamStore()
  const { navigate } = usePage()
  const filter = useCallback(q => q.eq("team", selectedTeam?.id), [selectedTeam])
  // The assistant changes channels from any page; reload the list when it does
  const tableKey = useAssistantChangeKey()

  const menu: DropdownMenuContents = [
    {
      title: "Copy Webhook for QA", action: (v) => navigator.clipboard.writeText(`${QABaseURL}/${v.id}`),
      icon: <Copy />,
    },
    {
      title: "Copy Webhook for Prod", action: (v) => navigator.clipboard.writeText(`${PRODBaseURL}/${v.id}`),
      icon: <Copy />,
    },
    {
      title: "Delete", action: async (v) => {
        await supabase.from("channels").delete().eq("id", v.id)
      },
      icon: <Trash2 />,
      ask: "Are you sure you want to delete this channel?",
    },
  ]


  return <Page>
    <div className="h-full grid grid-rows-[auto_1fr] gap-4">
      <div className="flex">
        <PageTitle />
        <div className="grow"></div>
        <div>
          <Button className="rounded-lg" onClick={() => navigate('/settings/channels/new')}><Plus className="h-4 w-4" />New Channel</Button>
        </div>
      </div>
      <DataTableSupabase
        key={tableKey}
        table="channels"
        columns={columns}
        showSelection
        onRowClick={"/settings/channels"}
        sort={["created_at", "desc"]}
        actions={menu.length > 0 ? menu : undefined}
        filter={filter}
        enableServerSideFiltering={true}
        select={`
        *,
        agent (
          title
        )
      `}
        searchableColumns={["title", "type"]}
      />
    </div>
  </Page>

}
